import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page34/Key/E4answerKey.png",

    titleQuestion: [
      {
        num: "4",
        title: "Viết tiếp vào chỗ chấm cho thích hợp.",
        color: "rgb(99,197,244)",
      },
    ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chỗ chấm để điền câu trả lời.</span>
                <video src="Audios/bt_fpt_ai/guide/p34_e2.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    component: T6,
    totalInput: 5,
    isHiddenCheck: true,
    // Recorder: true,
    // titleImage: "",
    inputSize: 80,
    // isAllowSubmit: false,
    questionImage: [],
    // maxLength: 1,
    stylesTextInput: {
      textAlign: "center",
      fontSize: 24,
      maxLength: 1,
      borderBottom: "2px dotted black",
      height: 22,
      textTransform: "uppercase",
    },
    questions: [
      {
        title: `
      <div>Mi cắt giấy màu các chữ cái Tiếng Anh sau:</div>
			<img src='/img/FriendsPlus/Page34/E4/1.jpg' style='height: 13cm; margin-bottom: 20px; '/> <br>
		  <ul>
       <li style= "list-style-type: disc; color: black">
         <span>Chữ </span>
         <input id= "0">
         <span> và </span>
         <input id= "1">
         <span> có đúng hai góc nhọn.</span>
       </li>
       <li style= "list-style-type: disc; color: black">
         <span>Chữ </span>
         <input id= "2">
         <span> và </span>
         <input id= "3">
         <span> có nhiều góc vuông nhất.</span>
       </li>
       <li style= "list-style-type: disc; color: black">
         <span>Chữ </span>
         <input id= "4">
         <span> có nhiều góc tù nhất.</span>
       </li>
      </ul>
			`,
        answer: [`N | Z`, `Z | N`, `E | H`, `H | E`, `W`],
      },
    ],
  },
  1: {
    // Exercise num
    unit: "Unit 3",
    id: "FGF11-U3-P45-E2",
    audio: "",
    video: "",
    component: MatchDots,
    hideBtnFooter: true,
    exerciseKey: "img/FriendsPlus/Page11/E1/key/E1answerKey.png",
    titleQuestion: [
      {
        num: "1",
        title: `
          Nối ba điểm sau để được hai đoạn thẳng trở thành một góc nhọn.
          `,
        color: "rgb(99,197,244)",
      },
    ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào từng chấm tròn tại các điểm <b> L, A, G </b>để nối thành một đoạn thẳng.</span>
        <video src="Audios/bt_fpt_ai/guide/p34_e1.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    stylesTextInput: { borderBottom: "10px dashed", textAlign: "center" },
    inputSize: 50,
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [
          {
            boxMatchStyle: {
              position: "absolute",
              top: "51px",
              left: "261px",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              border: 0,
              background: "black ",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "151px",
              left: "365px",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "51px",
              left: "521px",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              border: 0,
              background: "black",
            },
          }, // 3
        ],
        answers: ["0-2", "1-2 / 0-0", "0-1 / 0-0"],
        initialValue: [],
      },
      Layout: `
            <table style= "border: 2px solid black">
             <tr style= "border: 2px solid black">
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
             </tr>
             <tr style= "border: 2px solid black">
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
             </tr>
             <tr style= "border: 2px solid black">
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
             </tr>
             <tr style= "border: 2px solid black">
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
               <td style= "border: 2px solid black; width: 52px; height: 50px"></td>
             </tr>
            </table>
            <div style= "position: relative; font-weight: bold; top: -180px; left: 240px; color: black; font-size: 22px">L</div>
            <div style= "position: relative; font-weight: bold; top: -86px; left: 343px; color: black; font-size: 22px">A</div>
            <div style= "position: relative; font-weight: bold; top: -246px; left: 500px; color: black; font-size: 22px">G</div>
            <input id='0' type= 'boxMatch' />
            <input id='1' type= 'boxMatch' />
            <input id='2' type= 'boxMatch' />
        `,
    },
  },
};

export default json;
